import React, { useEffect } from "react";
import { useStaffAppraisalsStore } from "../../../../../config/stores";
import { Form, message } from "antd";
import { useForm } from "antd/es/form/Form";
import AppButton from "../../../../common/AppButton";
import AppInput from "../../../../common/AppInput";
import { meanBy, round } from "lodash";

const OverallPerformance = () => {
  const staffAppraisalStore = useStaffAppraisalsStore();
  const { creating, staffAppraisalDetails } = staffAppraisalStore;
  const [form] = useForm();

  const onSubmit = () => {
    form
      .validateFields()
      .then((data) => {
        const payload = data;
        payload.submitted_by_supervisor = true;
        staffAppraisalStore.updateStaffAppraisal(
          staffAppraisalDetails.id,
          payload
        );
      })
      .catch((err) => message.error("Please fill in all fields correctly"));
  };

  useEffect(() => {
    const annualTargetsAchievement = round(
      meanBy(staffAppraisalDetails.self_assessment, (assessment) => {
        if (assessment.rating_scale) {
          return assessment.rating_scale;
        }

        return 0;
      })
    );
    const capacityDevelopmentGoals = round(
      meanBy(staffAppraisalDetails.capacityDevelopmentGoals, (assessment) => {
        if (assessment.rating_scale) {
          return assessment.rating_scale;
        }

        return 0;
      })
    );

    const softSkills = round(
      meanBy(staffAppraisalDetails.softSkillEnhancements, (assessment) => {
        if (assessment.rating) {
          return assessment.rating;
        }

        return 0;
      })
    );

    const overallPerformance = round(
      (annualTargetsAchievement + capacityDevelopmentGoals + softSkills) / 3
    );

    form.setFieldsValue({
      achievement_of_target_rating: isNaN(annualTargetsAchievement)
        ? 0
        : annualTargetsAchievement,
      soft_skills_enhancement: isNaN(softSkills) ? 0 : softSkills,
      capacity_development_goals_rating: isNaN(capacityDevelopmentGoals)
        ? 0
        : capacityDevelopmentGoals,
      overall_performance_rating: overallPerformance,
    });
  }, [creating, staffAppraisalDetails, form]);

  return (
    <>
      <Form layout="vertical" form={form}>
        <AppInput
          label="Achievement of Targets"
          name="achievement_of_target_rating"
          options={[
            { label: "Unsatisfactory (1)", value: 1 },
            { label: "Needs Improvement (2)", value: 2 },
            { label: "Meets Expectations (3)", value: 3 },
            { label: "Exceeds Expectations (4)", value: 4 },
            { label: "Outstanding (5)", value: 5 },
          ]}
          type="select"
          rules={[{ required: true, message: "This field is required" }]}
        />
        <AppInput
          label="Soft Skills Enhancement"
          name="soft_skills_enhancement"
          options={[
            { label: "Unsatisfactory (1)", value: 1 },
            { label: "Needs Improvement (2)", value: 2 },
            { label: "Meets Expectations (3)", value: 3 },
            { label: "Exceeds Expectations (4)", value: 4 },
            { label: "Outstanding (5)", value: 5 },
          ]}
          type="select"
          rules={[{ required: true, message: "This field is required" }]}
        />
        <AppInput
          label="Capacity Development Goals"
          name="capacity_development_goals_rating"
          options={[
            { label: "Unsatisfactory (1)", value: 1 },
            { label: "Needs Improvement (2)", value: 2 },
            { label: "Meets Expectations (3)", value: 3 },
            { label: "Exceeds Expectations (4)", value: 4 },
            { label: "Outstanding (5)", value: 5 },
          ]}
          type="select"
          rules={[{ required: true, message: "This field is required" }]}
        />
        <AppInput
          label="Overall Performance"
          name="overall_performance_rating"
          options={[
            { label: "Unsatisfactory (1)", value: 1 },
            { label: "Needs Improvement (2)", value: 2 },
            { label: "Meets Expectations (3)", value: 3 },
            { label: "Exceeds Expectations (4)", value: 4 },
            { label: "Outstanding (5)", value: 5 },
          ]}
          type="select"
          rules={[{ required: true, message: "This field is required" }]}
        />
        <AppButton
          text="SUBMIT EMPLOYER SECTION"
          key={"create"}
          block
          disabled={staffAppraisalDetails.status === "approved"}
          loading={staffAppraisalStore.updatingStaffAppraisal}
          onClick={onSubmit}
        />
      </Form>
      {/* <Divider className="m-1" /> */}
    </>
  );
};

export default OverallPerformance;
